<script setup>
// GK-HUB: Refactored to use shared AutoResolveConfig component
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import AutoResolveConfig from 'dashboard/components-next/auto-resolve/AutoResolveConfig.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();
const labels = useMapGetter('labels/getLabels');
const isSubmitting = ref(false);

const config = computed(() => ({
  auto_resolve_after: currentAccount.value?.settings?.auto_resolve_after,
  auto_resolve_message: currentAccount.value?.settings?.auto_resolve_message,
  auto_resolve_ignore_waiting:
    currentAccount.value?.settings?.auto_resolve_ignore_waiting,
  auto_resolve_label: currentAccount.value?.settings?.auto_resolve_label,
}));

const handleSave = async settings => {
  try {
    isSubmitting.value = true;
    await updateAccount(settings, { silent: true });
    useAlert(t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE.DURATION.API.SUCCESS'));
  } catch {
    useAlert(t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE.DURATION.API.ERROR'));
  } finally {
    isSubmitting.value = false;
  }
};

const handleDisable = async () => {
  await handleSave({
    auto_resolve_after: null,
    auto_resolve_message: '',
    auto_resolve_ignore_waiting: false,
    auto_resolve_label: null,
  });
};
</script>

<template>
  <AutoResolveConfig
    :config="config"
    :labels="labels"
    :is-submitting="isSubmitting"
    @save="handleSave"
    @disable="handleDisable"
  />
</template>
